import React from 'react';
import axios from 'axios';
import ExtraSearchForm from 'containers/extra/extraSearchForm';
import ExtraEdit from 'containers/extra/extraEdit';
import { Layout, Divider, Spin, Table, Comment, Avatar, Button, Space, Row, Col, message, Rate } from 'antd';
import { Link } from 'react-router-dom';
import {
    PlusOutlined,
    EyeOutlined,
} from '@ant-design/icons';

const { Content } = Layout;

const desc = ['terrible', 'bad', 'normal', 'good', 'wonderful'];

const imgUrl = 'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1589345527573&di=84dce0ddfaa4487d960217035d08ae37&imgtype=0&src=http%3A%2F%2F5b0988e595225.cdn.sohucs.com%2Fimages%2F20180324%2F97424c485abc4ce9a9fd7b3606d9027c.jpeg';

const items: any = [];
for (var i = 0; i < 9; i++) {
    items.push(<img src={imgUrl} width="120" height="90" />);
}

const ExampleComment = ({ children }: any) => (
    <Comment
        actions={[<Button type="default" size="middle" key="comment-nested-reply-to">回评</Button>]}
        author={<Space><a><strong>Han Solo</strong></a>2020.05.21 12: 58</Space>}
        avatar={
            < Avatar
                src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"
                alt="Han Solo"
            />
        }
        content={
            < div >
                <p>
                    <span>
                        <Rate disabled defaultValue={4} />
                    </span>
                </p>
                <p>
                    We supply a series of design principles, practical patterns and high quality design
                    resources (Sketch and Axure).
                </p>
                <p style={{ marginTop: '15px' }}>
                    <Row gutter={[18, 18]}>
                        {
                            items.map((item: any, index: any) => {
                                return <Col>{item}</Col>;
                            })
                        }
                    </Row>
                </p>
            </div >
        }
    >
        {children}
    </Comment >
);


const ExampleReply = ({ children }: any) => (
    <Comment
        actions={[<span key="comment-nested-reply-to">删除</span>]}
        author={<Space><a><strong>Han Solo</strong></a>2020.05.21 12: 58</Space>}
        avatar={
            <Avatar
                src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"
                alt="Han Solo"
            />
        }
        content={
            <div>
                <p>
                    We supply a series of design principles, practical patterns and high quality design
                    resources (Sketch and Axure).
                </p>
            </div>
        }
    >
        {children}
    </Comment>
);

class CommentList extends React.Component {
    constructor(props: any) {
        super(props);
        this.getMembers();
    }

    state = {
        memberData: [],
        userInfo: [],
        loading: true,
        total: 0,
        editorVisible: false,
        editorTitle: "Modal Title",
        dataId: 0,
    };

    getMembers = () => {
        axios.get('https://www.fastmock.site/mock/9973669a2a13cbb70690fdf6f1880e97/admin/extra/list', {
            params: {}
        })
            .then((res) => {
                console.log('res', res.data.data.list)
                this.setState({
                    memberData: res.data.data.list,
                    total: res.data.data.total,
                    loading: false
                })
            })
            .catch((err) => {
                console.log(err)
            })
    };



    createData = () => {
        this.setState({
            editorVisible: true,
            editorTitle: "新增资源"
        });
    };

    editData = (text: number): any => {
        this.setState({
            dataId: text,
            editorVisible: true,
            editorTitle: "编辑资源 ID - " + text.toString(),
        });
    }

    deleteConfirm = (text: number): any => {
        message.warning("删除了id" + text.toString());
    }

    render() {
        let userInfo: any = this.state.userInfo;
        console.log('userInfo', userInfo);
        return (
            <div>
                <Content
                    style={{
                        padding: 24,
                        background: '#fff',
                        minHeight: 680,
                    }}
                >
                    <Row gutter={[18, 0]}>
                        <Col><Button type="primary" onClick={this.createData}><PlusOutlined /> 新增资源</Button></Col>
                        <Col><ExtraSearchForm /></Col>
                    </Row>

                    <Divider />

                    <ExampleComment>
                        <ExampleReply />
                        <ExampleReply />
                    </ExampleComment>
                    <Divider />
                    <ExampleComment />

                    <Divider />
                    <ExampleComment />
                    <Divider />
                    <ExampleComment />
                    <Divider />
                    <ExampleComment />
                    <Divider />
                    <ExampleComment />
                </Content >
            </div >
        );
    }
}

export default CommentList;